import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function PromptEngineerReview({ config, onBack, onContinue }) {
    return (
        <Card elevation={2}>
            <CardContent>
                <Stack spacing={2}>
                    <Typography variant="h6">Review JSON</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Review your full configuration object before moving into the engineering step.
                    </Typography>
                    <Box
                        component="pre"
                        sx={{
                            m: 0,
                            p: 2,
                            borderRadius: 2,
                            overflowX: 'auto',
                            fontSize: 13,
                            lineHeight: 1.6,
                            border: '1px solid',
                            borderColor: 'divider',
                            backgroundColor: '#0b1220',
                            color: '#d6e1ff'
                        }}
                    >
                        {JSON.stringify(config, null, 2)}
                    </Box>
                    <Stack direction="row" spacing={2}>
                        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={onBack}>
                            Back
                        </Button>
                        <Button variant="contained" onClick={onContinue}>
                            Continue
                        </Button>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}
